<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <base-card
                        title="Search Form"
                        :v-card-text-class="'pa-0'"

                        :loading-allowed="false"
                    >
<v-form @submit.prevent="submit">
                                <v-row class="px-2 pt-4 pb-0">
                                    <v-col  md="3" cols="12">
                                        <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="From Date"
                                        density="compact"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi mdi-calendar-month"
                                        single-line
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="from_date.value.value"
                                        :error-messages="from_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                    ></v-date-input>
                                    </v-col>

                                    <v-col  md="3" cols="12">
                                        <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="To Date"
                                        density="compact"
                                        single-line
                                        prepend-icon=""
                                        prepend-inner-icon="mdi mdi-calendar-month"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="to_date.value.value"
                                        :error-messages="to_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                        ></v-date-input>
                                        </v-col>

                                </v-row>
                                <v-divider></v-divider>
                                <v-card-actions class="justify-end">
                                  <v-btn
                                      ref="searchButton"
                                      class="bg-brand"
                                      prepend-icon="mdi-magnify"
                                      type="submit"
                                  >
                                    Search
                                  </v-btn>
                                </v-card-actions>
                            </v-form>
                    </base-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <base-card
            title="Customer List"
            :v-card-text-class="'pa-0'"
            :loading-allowed="false"
          >
                                    <v-row class="py-2">
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/master-data/add-customer')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Customer
                                                </v-btn>
                                            </div>
                                        </v-col>

                                    </v-row>
                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact">
                        <template v-slot:loader>
                            <v-progress-linear
                                :color="loading"
                                height="3"
                                indeterminate
                            />
                        </template>

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.company_country="{ item }">
                                            {{ item.company_country?.name }}
                                        </template>

                                        <template v-slot:item.type="{ item }">
                                            {{ item.type?.name }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon

                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>

          </base-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import BaseCard from '@/components/utils/baseCard.vue';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import formattedDate from '@/plugins/dateFormatter';

export default {
        components: {
        BaseCard,},
        data: () => ({
            itemsPerPage:10,
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code",align: "left" ,sortable: false },
                { title: "Name", key: "company_name",align: "left" ,sortable: false },
                { title: "Type", key: "type",align: "left" ,sortable: false },
                { title: "Email", key: "company_email",align: "left" ,sortable: false },
                { title: "Mobile", key: "company_mobile",align: "left" ,sortable: false },
                { title: "Address", key: "company_address",align: "left" ,sortable: false },
                //{ title: "Country", key: "company_country",align: "left" ,sortable: false },
                // { title: "VAT", key: "company_vat",align: "left" ,sortable: false },
                // { title: "TIN", key: "company_tin",align: "left" ,sortable: false },
                // { title: "BIN", key: "company_bin",align: "left" ,sortable: false },
                // { title: "Contact Name", key: "contacts[0].name",align: "left" ,sortable: false },
                // { title: "Contact Number", key: "contacts[0].mobile",align: "left" ,sortable: false },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),

        watch: {},
        created(){},

        computed:{
            getSchema() {
                return this.$store.getters.getCustomerList;
            },
        },
        setup() {
            const { handleSubmit, resetForm } = useForm();
            const from_date = useField("from_date");
            const to_date = useField("to_date");
            const errorMessages = ref("");
            const loading = ref("");
            const store = useStore();
            const submit = handleSubmit((values) => {
                loading.value = 'blue-darken-3';
                values.from_date = formattedDate(from_date.value.value);
                values.to_date = formattedDate(to_date.value.value);

                store.dispatch('getCustomerList', values).
                then(() => {
                    loading.value = false;
                }).catch((error) => {
                    loading.value = false;
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessages.value = error.response.data.message;
                        toast.error(errorMessages.value);
                    } else {
                        errorMessages.value = "An error occurred while fetching data.";
                        toast.error(errorMessages.value);
                    }
                });
            });
            return {
                from_date,
                to_date,
                errorMessages,
                loading,
                submit,
                resetForm
            };
        },
        methods: {
            goTo(val) {
                this.$router.push({ path: val });
            },
            editItem(item){
                this.$store.commit('setEditingCustomer', item);
                this.$router.push({ name: 'add-customer' });
                // this.data = { ...item };
                // this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                this.$exportTableToPDF(columns,rows,'Customer List','customer_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                });
                this.$exportTableToExcel(data,'customer_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                });

                this.$exportTableToCSV(data,'customer_list_' + this.$fileDate());
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.searchButton.$el.click();
            });
        }
    }
</script>
